import React, { useState } from 'react';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { assistanceBadgeDescription, assistanceBadgeTitle, framerCommon } from '../../framer.variants';
import { useCheckMobile } from '../../hooks';
import { data_assistance_banner } from './content';

export default function AssistanceBanner() {
  const { image, title, description } = data_assistance_banner;

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.9,
  });

  return (
    <div ref={ref} className="bg-demo-xr-blue">
      <div className="gl-wrapper flex items-center gap-[45px] sm:gap-4">
        <img className="relative -top-[0.5rem] w-[6.625rem]" src={image} alt="" />
        <div>
          <div className="relative">
            <motion.p
              {...framerCommon}
              transition={{ duration: 0.5, delay: 0.75 }}
              initial={{ scale: 2.5, marginLeft: '29%' }}
              animate={{ scale: inView ? 1 : 2.5, marginLeft: inView ? '0' : '29%' }}
              className="absolute font-Proxima text-subtitle font-black leading-tight text-white lg:hidden sm:text-[20px]"
            >
              {title}
            </motion.p>
            <p className="invisible min-h-[1.875rem] font-Proxima text-subtitle leading-tight text-white lg:visible sm:text-[20px]">
              {title}
            </p>
          </div>
          <motion.p
            {...framerCommon}
            transition={{ duration: 0.35, delay: 1.25 }}
            initial={{ height: '1px', bottom: '-20%' }}
            animate={{ height: inView ? '100%' : '1px', bottom: inView ? '0' : '-20%' }}
            className="lg:!translate-[unset] relative overflow-hidden font-Proxima text-subtitle font-black leading-tight text-white lg:!h-full lg:!transform-none sm:text-[20px]"
          >
            {description}
          </motion.p>
        </div>
      </div>
    </div>
  );
}
